import * as pc from 'playcanvas';
import {MaterialManager} from './MaterialManager';

const UI = {
  e_screen: {},
  screen: {},
  init: function(playcanvasApp) {
    this.playcanvasApp = playcanvasApp;
    this.root = playcanvasApp.root;

    // create master UI entity
    this.e_screen = new pc.Entity('e_ui');
    this.screen = this.e_screen.addComponent('screen', {
      referenceResolution: new pc.Vec2(2048, 2048),
      scaleBlend: 1,
      scaleMode: pc.SCALEMODE_BLEND,
      screenSpace: true,
    });
    this.root.addChild(this.e_screen);
  },
  resizeHandler: function(w, h, pxRatio) {
  },

  ////////////////////////////////////////////////////////////////
  // HELPER METHODS
  ////////////////////////////////////////////////////////////////
  addGroupElement: function(name, parent) {
    const e = new pc.Entity('e_' + name);
    e.addComponent('element', {
      type: 'group',
      anchor: new pc.Vec4(0.5, 0.5, 0.5, 0.5),
      pivot: new pc.Vec2(0.5, 0.5),
    });
    parent.addChild(e);
    return e;
  },
  addImageElement: function(name, parent, assetName) {
    const e = new pc.Entity('e_' + name);
    // console.log("addimage: " + assetName);
    const asset = this.playcanvasApp.assets.find(assetName).resource;
    e.addComponent('element', {
      type: 'image',
      anchor: new pc.Vec4(0.5, 0.5, 0.5, 0.5),
      pivot: new pc.Vec2(0.5, 0.5),
      width: asset.width,
      height: asset.height,
      texture: asset,
    });
    parent.addChild(e);
    return e;
  },
  addTextElement: function(name, parent, text = '', fontSize = 42) {
    const e = new pc.Entity('e_' + name);
    e.addComponent('element', {
      type: 'text',
      anchor: new pc.Vec4(0.5, 0.5, 0.5, 0.5),
      pivot: new pc.Vec2(0.5, 0.5),
      fontSize: fontSize,
      text: text,
    });
    parent.addChild(e);
    return e;
  },
  addShaderElement: function(name, parent, width, height, shaderName) {
    const e = new pc.Entity('e_' + name);
    e.addComponent('element', {
      type: 'image',
      anchor: new pc.Vec4(0.5, 0.5, 0.5, 0.5),
      pivot: new pc.Vec2(0.5, 0.5),
      width: width,
      height: height,
      material: MaterialManager.getShaderMaterial(shaderName),
    });
    parent.addChild(e);
    return e;
  },
  setAnchor: function(entity, left, bottom, right, top) {
    entity.element.anchor = new pc.Vec4(left, bottom, right, top);
  },
  setPivot: function(entity, x, y) {
    entity.element.pivot = new pc.Vec2(x, y);
  },
  setOpacity: function(entity, opacity) {
    entity.element.opacity = opacity;
  },
  computeScale(elementSize, targetSize, scaleMode='cover') {
    const elementRatio = elementSize.width / elementSize.height;
    const targetRatio = targetSize.width / targetSize.height;

    switch (scaleMode) {
      case 'cover':
        if (targetRatio > elementRatio) return targetSize.width / elementSize.width;
        else return targetSize.height / elementSize.height;
      case 'fit':
        if (targetRatio > elementRatio) return targetSize.height / elementSize.height;
        else return targetSize.width / elementSize.width;
      default:
        return 1;
    }
  },
  scaleElementToFitCamera(element, camera) {
    // TODO: Make this less brittle: currently only works when the camera and element are aligned on
    // the z axis and orthogonal to it

    // Get element's dimensions. Ideally, this would be screen-space dimensions
    const worldCorners = element.worldCorners;
    const elWidth = Math.abs(worldCorners[0].x - worldCorners[2].x);
    const elHeight = Math.abs(worldCorners[0].y - worldCorners[2].y);

    // Compute distance to camera
    const d = Math.abs(camera.entity.localPosition.z - worldCorners[0].z);

    // Compute target size
    const verticalTargetSize = 2*Math.tan(camera.fov)*d;
    const horizontalTargetSize = verticalTargetSize * camera.aspectRatio;

    return UI.computeScale({width: elWidth, height: elHeight}, {width: horizontalTargetSize, height: verticalTargetSize}, 'cover');
  },
};

export {UI};
